import { IconAddTag } from 'common/components/Icons/IconAddTag/IconAddTag';
import { IconExportCSV } from 'common/components/Icons/IconExportCSV/IconExportCSV';
import { IconRemoveTag } from 'common/components/Icons/IconRemoveTag/IconRemoveTag';
import { PathNames } from 'common/constants/pathNames';
interface ITabset {
  [key: string]: ITab;
}
interface ITab {
  title: string;
  key: string;
  link: string;
  IconComponent: any;
  permissionOpen: boolean;
  active: boolean;
  showSummary: boolean;
  columnPickerPath: string;
  gridPath: string;
  tabPath: string;
  count: number;
  lockedTo?: string[];
  featureFlag?: string;
}
export const TABSET: ITabset = {
  internalAssets: {
    title: 'Org Assets',
    key: 'internal_assets',
    IconComponent: null,
    link: '/pages/discovery/internalAssets',
    permissionOpen: true,
    active: false,
    showSummary: true,
    columnPickerPath: PathNames.internalAssetsColumns,
    gridPath: PathNames.internalAssets,
    tabPath: PathNames.internalAssetsSummary,
    count: 0
  },
  digitalSupplyChain: {
    title: 'Digital Supply Chain',
    key: 'external_assets',
    IconComponent: null,
    link: '/pages/discovery/digitalSupplyChain',
    permissionOpen: true,
    active: false,
    showSummary: true,
    columnPickerPath: PathNames.digitalSupplyChainColumns,
    gridPath: PathNames.digitalSupplyChain,
    tabPath: PathNames.digitalSupplyChainSummary,
    count: 0
  },
  publicCloud: {
    title: 'Cloud Integration',
    key: 'cloud_assets',
    IconComponent: null,
    link: '/pages/discovery/publicCloud/?filters=%7B"is_public_facing"%3A1%7D',
    permissionOpen: true,
    active: false,
    showSummary: false,
    columnPickerPath: PathNames.publicCloudColumns,
    gridPath: PathNames.publicCloud,
    tabPath: '',
    count: 0,
    featureFlag: 'isCcv'
  },
  loginAssets: {
    title: 'Login Assets',
    key: 'login_assets',
    IconComponent: null,
    link: '/pages/discovery/loginAssets',
    permissionOpen: true,
    active: false,
    showSummary: true,
    columnPickerPath: PathNames.loginAssetsColumns,
    gridPath: PathNames.loginAssets,
    tabPath: PathNames.loginAssetsSummary,
    count: 0
  },
  managedDomains: {
    title: 'Managed Domains',
    key: 'managed_domains',
    IconComponent: null,
    link: '/pages/discovery/managedDomains',
    permissionOpen: true,
    active: false,
    showSummary: false,
    columnPickerPath: PathNames.managedDomainsColumns,
    gridPath: PathNames.managedDomains,
    tabPath: PathNames.managedDomainsSummary,
    count: 0
  },
  certificates: {
    title: 'Certificates',
    key: 'certificates',
    IconComponent: null,
    link: '/pages/discovery/certificates',
    permissionOpen: true,
    active: false,
    showSummary: false,
    columnPickerPath: PathNames.certificatesColumns,
    gridPath: PathNames.certificates,
    tabPath: PathNames.certificatesSummary,
    count: 0
  },
  unlinkedAssets: {
    title: 'Unlinked Assets',
    key: 'unlinked_assets',
    IconComponent: null,
    link: '/pages/discovery/unlinkedAssets',
    permissionOpen: true,
    active: false,
    showSummary: false,
    columnPickerPath: PathNames.unlinkedAssetsColumns,
    gridPath: PathNames.unlinkedAssets,
    tabPath: PathNames.unlinkedAssetsSummary,
    count: 0,
    featureFlag: 'isUnlinkedAssets'
  },
  mobileAssets: {
    title: 'Mobile Apps',
    key: 'mobile_assets',
    IconComponent: null,
    link: '/pages/discovery/mobileAssets',
    permissionOpen: true,
    active: false,
    showSummary: false,
    columnPickerPath: PathNames.mobileAssetsColumns,
    gridPath: PathNames.mobileAssets,
    tabPath: PathNames.mobileAssetsSummary,
    count: 0,
    featureFlag: 'isMobile'
  }
};

export const OPTIONS = [
  {
    IconComponent: IconAddTag,
    label: 'Add Tags',
    ff: 'isCustomTags'
  },
  {
    IconComponent: IconRemoveTag,
    label: 'Remove Tags',
    ff: 'isCustomTags'
  },
  {
    IconComponent: IconExportCSV,
    label: 'Export Discovery Evidence'
  }
];
